module.exports = __webpack_public_path__ + "img/coininfo-pay-active.3cb0a2d2.png";